var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBurgerMenu = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 17,
  viewBox: "0 0 19 17",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M1.14 14.082h16.074c.627 0 1.14.523 1.14 1.166 0 .642-.513 1.165-1.14 1.165H1.14c-.628 0-1.14-.523-1.14-1.165 0-.643.512-1.166 1.14-1.166m0-7.04h11.491c.629 0 1.14.522 1.14 1.164 0 .643-.511 1.166-1.14 1.166H1.14C.512 9.372 0 8.848 0 8.206c0-.642.512-1.164 1.14-1.164m16.098-4.71H1.14C.512 2.331 0 1.807 0 1.165 0 .523.512 0 1.14 0h16.074c.627 0 1.14.523 1.14 1.166 0 .642-.488 1.165-1.116 1.165"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBurgerMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/burger-menu.3c1085586b2402f8019ee82e7ecf205f.svg";